<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="d-flex with-button">
          <div class="p-2">
            <h1 class="title">알림톡 전송 내역</h1>
          </div>
          <div class="p-2 small bottom">
            총 <strong><span class="number mint">{{tableTotal}}</span></strong> 건
          </div>
          <div class="ml-auto p-2" v-if="isKakaoAuth">
            <button type="button" class="btn gray" @click="openKakaoAccount">알림톡 사용정산내역</button>
            <button type="button" class="btn mint" @click="retrieveKakaoBalance">알림톡 잔여내역</button>
          </div>
        </div>

        <div class="d-flex">
          <div class="p-2 w-100">
            <div class="card-body gray search-group">
              <el-row :gutter="10">
                <el-col :span="3" class="search-label">
                  알림톡 유형
                </el-col>
                <el-col :span="5">
                  <el-select v-model="search.kakao_type" placeholder="알림톡 유형">
                    <el-option label="전체" value=""></el-option>
                    <el-option v-for="option in kakaoTypes" :label="option.code_name" :value="option.code_id" :key="option.code_id"></el-option>
                  </el-select>
                </el-col>

                <el-col :span="3" class="search-label">
                  전송 기간
                </el-col>
                <el-col :span="5">
                  <el-date-picker
                    v-model="sendDate"
                    type="daterange"
                    range-separator="~"
                    format="yyyy.MM.dd"
                    value-format="yyyyMMdd"
                    start-placeholder="전송 시작일"
                    end-placeholder="전송 종료일">
                  </el-date-picker>
                </el-col>

                <el-col :span="3" class="search-label">
                  전송 상태
                </el-col>
                <el-col :span="5">
                  <el-select v-model="search.kakao_stat" placeholder="전송 상태">
                    <el-option label="전체" value=""></el-option>
                    <el-option v-for="option in kakaoStats" :label="option.code_name" :value="option.code_id" :key="option.code_id"></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </div>
            <div class="input-group search">
              <div class="input-group-prepend">
                <span class="input-group-text"><i class="fas fa-search"></i></span>
              </div>
              <input type="text" class="form-control" aria-describedby="basic-addon1" v-model="search.search_text" @keyup.enter="retrieve">
              <div class="input-group-apend">
                <button type="button" class="btn btn-default" @click="retrieve">
                  검색
                </button>
              </div>
            </div>
          </div>
          <div class="p-2 search-detail" v-if="searchDetailVisible">
            <a href="#" class="arrowdown"><i class="fas fa-angle-double-down"></i></a>
          </div>
        </div>
      </div>

      <stone-data-table-server
        ref="dataTableServer"
        table-ref="dataTableServer"
        :loading="searchLoading"
        :columns="tableColumns"
        :data="tableData"
        :table-props="tableProps"
        @query-change="tableLoadData"
        @row-click="rowClickHandler">
      </stone-data-table-server>
    </div>

    <el-dialog title="알림톡 잔여내역" :visible.sync="balanceDialogVisible" width="500px">
      <table class="balanceListTable">
        <thead>
          <tr>
            <th rowspan="2">선불입금내역<br/>(이월금액)</th>
            <th colspan="3">사용내역</th>
            <th rowspan="2">잔여내역</th>
          </tr>
          <tr>
            <th>카카오 알림톡</th>
            <th>SMS</th>
            <th>LMS</th>
          </tr>
        </thead>
        <tfoot>
          <tr>
            <td rowspan="2">{{balance.deposit}}<br/>{{`(${balance.carry_balance})`}}</td>
            <td>{{balance.kakaotalk}}</td>
            <td>{{balance.sms}}</td>
            <td>{{balance.lms}}</td>
            <td rowspan="2">{{balance.balance}}</td>
          </tr>
          <tr>
            <td colspan="3" class="total">{{balance.use_amount}}</td>
          </tr>
        </tfoot>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="balanceDialogVisible = false">확인</el-button>
      </span>
    </el-dialog>

    <el-dialog title="알림톡 사용정산내역" :visible.sync="accountDialogVisible" width="700px">
      <el-row style="margin-bottom: 10px;">
        <el-date-picker v-model="accountStartDate" type="month" value-format="M-yyyy" placeholder="월을 선택하세요."></el-date-picker>
        <el-button type="info" @click="retrieveKakaoAccount">검색</el-button>
      </el-row>
      <table class="balanceListTable calculation">
        <thead>
          <tr>
            <th rowspan="2">사용일시</th>
            <th colspan="3">카카오 알림톡</th>
            <th colspan="3">SMS</th>
            <th colspan="3">LMS</th>
          </tr>
          <tr>
            <th>전체</th>
            <th>성공</th>
            <th>실패</th>
            <th>전체</th>
            <th>성공</th>
            <th>실패</th>
            <th>전체</th>
            <th>성공</th>
            <th>실패</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{account.deposit_date}}</td>
            <td>{{account.kakaotalk}}</td>
            <td>{{account.kakaotalk - account.fail_kakaotalk}}</td>
            <td>{{account.fail_kakaotalk}}</td>
            <td>{{account.sms}}</td>
            <td>{{account.sms - account.fail_sms}}</td>
            <td>{{account.fail_sms}}</td>
            <td>{{account.lms}}</td>
            <td>{{account.lms - account.fail_lms}}</td>
            <td>{{account.fail_lms}}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <th>합계</th>
            <td>{{account.kakaotalk}}</td>
            <td>{{account.kakaotalk - account.fail_kakaotalk}}</td>
            <td>{{account.fail_kakaotalk}}</td>
            <td>{{account.sms}}</td>
            <td>{{account.sms - account.fail_sms}}</td>
            <td>{{account.fail_sms}}</td>
            <td>{{account.lms}}</td>
            <td>{{account.lms - account.fail_lms}}</td>
            <td>{{account.fail_lms}}</td>
          </tr>
          <tr>
            <th>정산(성공건)</th>
            <td colspan="3" class="total">{{this.balanceCalculate((account.kakaotalk - account.fail_kakaotalk) * account.kakaotalk_amount)}}</td>
            <td colspan="3" class="total">{{this.balanceCalculate((account.sms - account.fail_sms) * account.sms_amount)}}</td>
            <td colspan="3" class="total">{{this.balanceCalculate((account.lms - account.fail_lms) * account.lms_amount)}}</td>
          </tr>
          <tr>
            <th>총합</th>
            <td colspan="9" class="total">{{this.accountTotal()}}</td>
          </tr>
        </tfoot>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="accountDialogVisible = false">확인</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import common from '@/modules/common'

export default {
  name: 'M990801',
  mixins: [common.mixins],
  data () {
    return {
      tableData: [],
      tableTotal: 0,
      tableProps: {height: this.getScreenHeight(60)},
      tableColumns: [
        {label: 'No', prop: 'rnum', align: 'left', width: 60, sortable: false},
        {label: '알림톡 유형', prop: 'template_name', align: 'left', width: 100},
        {label: '사용자', prop: 'phone_name', align: 'center', width: 80},
        {label: '수신전화번호', prop: 'phone', align: 'center', width: 100, formatter: this.columnFormatterPhone},
        // {label: '발신번호', prop: 'callback', align: 'center', width: 100, formatter: this.columnFormatterPhone},
        {label: '알림톡 내용', prop: 'msg', align: 'left', width: 200},
        {label: '전송일자', prop: 'send_date', align: 'center', width: 120},
        {label: '전송상태', prop: 'kakao_stat_name', align: 'center', width: 80},
        {label: '결과 메세지', prop: 'kakao_rslt_msg', align: 'left', width: 160},
        {label: 'CMID', prop: 'cmid', align: 'center', width: 100}
      ],
      search: {
        msg: '',
        search_text: '',
        kakao_type: '',
        send_from_date: '',
        send_to_date: '',
        kakao_stat: ''
      },
      actionCol: {
        label: ' ',
        props: {
          align: 'center',
          width: 120
        },
        buttons: [{
          handler: row => {
            this.sendKakao(row)
          },
          props: {
            type: 'primary',
            size: 'mini'
          },
          label: '재전송'
        }]
      },
      kakaoTypes: [],
      kakaoStats: [],
      sendDate: [this.addMomentDay(-7), this.addMomentDay(0)],
      balance: {
        deposit: '',
        carry_balance: '',
        kakaotalk: '',
        sms: '',
        lms: '',
        balance: '',
        use_amount: ''
      },
      balanceDialogVisible: false,
      account: {
        deposit_date: '',
        fail_kakaotalk: 0,
        fail_lms: 0,
        fail_sms: 0,
        kakaotalk: 0,
        kakaotalk_amount: 0,
        lms: 0,
        lms_amount: 0,
        sms: 0,
        sms_amount: 0
      },
      accountStartDate: this.formatterDate(new Date(), 'M-YYYY'),
      accountDialogVisible: false,
      isKakaoAuth: false
    }
  },
  created () {
    // 알림톡 내역 버튼은 시스템 관리자만 보이도록 한다.
    this.isKakaoAuth = this.$store.getters.auth_grp === 'SYS'
    this.getCommonCodes()
  },
  mounted () {
  },
  methods: {
    getCommonCodes () {
      Promise.all([
        common.axios.get('/code/KAKAO_TYPE/child'), // 알림톡 유형
        common.axios.get('/code/KAKAO_STAT/child') // 알림톡 상태
      ]).then(response => {
        this.kakaoTypes = response[0].data
        this.kakaoStats = response[1].data.filter(x => x.code_id !== 'A')
      })
    },
    getKakaoTypes () {
      common.axios.get('/code/KAKAO_TYPE/child')
        .then(response => {
          this.kakaoTypes = response.data
        })
    },
    retrieve () {
      const queryInfo = {page: 1, pageSize: 20, type: 'init', filters: [], sort: {}}
      this.tableLoadData(queryInfo)
      this.$refs.dataTableServer.localCurrentPage = 1
    },
    async tableLoadData (queryInfo) {
      if (this.sendDate && this.sendDate.length === 2) {
        this.search.send_from_date = this.sendDate[0]
        this.search.send_to_date = this.sendDate[1]
      } else {
        this.search.send_from_date = ''
        this.search.send_to_date = ''
      }
      const param = Object.assign({query: queryInfo}, this.search)
      if (param.query.sort.prop) {
        const prop = param.query.sort.prop
        if (prop === 'phone' || prop === 'callback') {
          param.query.sort.prop = 'KH.' + prop
        }
      }
      this.loadStoneDataTable('/kakao/history/list', param, true, false)
        .then(response => {
          this.tableData = response.data
          this.tableTotal = this.tableData && this.tableData.length > 0 ? this.tableData[0].total_count : 0
        })
    },
    rowClickHandler (row, event, column) {
      const columnName = column.property
      if (columnName === 'msg' && row.btn_urls1) {
        let url = ''
        if (row.btn_urls1.indexOf('http://me2.do') !== -1) {
          url = row.btn_urls1
        } else {
          url = row.btn_urls1.replace(/^(?:https?:)?(?:\/\/)?([^\\/\\?]+)/, window.location.origin)
        }
        // console.log('url : ', url)
        window.open(url, '_blank')
      } else if (columnName === 'cmid' || columnName === 'phone') {
        this.$clipboard(row[columnName])
        this.$message(column.label + this.searchJosa(column.label, '이/가') + ' 클립보드에 복사되었습니다.')
      }
    },
    sendKakao (row) {
      this.$confirm('재전송하시겠습니까?', '', {
      }).then(() => {
        common.axios.post('/kakao/msg/' + row.seq, {})
          .then(response => {
            // console.log(response.data)
            this.$message('재전송하였습니다.')
            this.retrieve()
          })
      }).catch(() => {})
    },
    reportKakao (row) {
      if (!row.cmid) {
        this.$message.warning('CMID 값이 없습니다!')
        return
      }
      const param = {
        seq: row.seq,
        cmid: row.cmid
      }
      common.axios.post('/kakao/report', param)
        .then(response => {
          // console.log(response.data)
          this.$message('결과 확인 정보를 업데이트 하였습니다.')
          this.retrieve()
        })
    },
    retrieveKakaoBalance () {
      this.balanceDialogVisible = true
      common.axios.get('/kakao/balance')
        .then(response => {
          const result = response.data
          // console.log('response : ', result)
          if (result) {
            Object.keys(this.balance).forEach(key => {
              this.balance[key] = result[key]
            })
          } else {
            this.$message('검색 결과가 없습니다.')
            Object.keys(this.balance).forEach(key => {
              this.balance[key] = ''
            })
          }
        })
        .catch(() => {
          Object.keys(this.balance).forEach(key => {
            this.balance[key] = ''
          })
        })
    },
    openKakaoAccount () {
      this.initKakaoAcount()
      this.accountDialogVisible = true
      this.$nextTick(() => {
        this.retrieveKakaoAccount()
      })
    },
    retrieveKakaoAccount () {
      // this.accountDialogVisible = true
      if (!this.accountStartDate) {
        this.$message.warning('정산월을 선택하십시오.')
        return
      }
      common.axios.get('/kakao/account?start_date=' + this.accountStartDate)
        .then(response => {
          const result = response.data
          // console.log('response : ', result)
          if (result) {
            Object.keys(this.account).forEach(key => {
              this.account[key] = result[key]
            })
          } else {
            this.$message('검색 결과가 없습니다.')
            this.initKakaoAcount()
          }
        })
        .catch(() => {
          this.initKakaoAcount()
        })
    },
    initKakaoAcount () {
      Object.keys(this.account).forEach(key => {
        this.account[key] = key === 'deposit_date' ? '' : 0
      })
    },
    balanceCalculate (amount) {
      return this.formatterNumeral(amount, '0,0') + '원'
    },
    accountTotal () {
      let smsAmount = parseFloat((this.account.sms - this.account.fail_sms) * this.account.sms_amount)
      let lmsAmount = parseFloat((this.account.lms - this.account.fail_lms) * this.account.lms_amount)
      let kakaotalkAmount = parseFloat((this.account.kakaotalk - this.account.fail_kakaotalk) * this.account.kakaotalk_amount)
      smsAmount = Math.round(smsAmount)
      lmsAmount = Math.round(lmsAmount)
      kakaotalkAmount = Math.round(kakaotalkAmount)
      let totalAmount = parseFloat(smsAmount + lmsAmount + kakaotalkAmount)
      totalAmount = Math.round(totalAmount)
      let totalAmountVat = parseFloat(totalAmount * 1.1)
      totalAmountVat = Math.round(totalAmountVat)
      return '공급가액(' + this.formatterNumeral(totalAmount, '0,0') + ')원 + 부가세(10%) = ' + this.formatterNumeral(totalAmountVat, '0,0') + '원'
    }
  }
}
</script>

<style scoped>
  .balanceListTable {
    width: 100%;
    margin: 0;
    border: 1px solid #ccc;
  }
  .balanceListTable th {
    padding: 8px 0;
    color: #333;
    font-size: 14px;
    border: 1px solid #ccc;
    background-color: #fbfbfb;
    text-align: center;
  }
  .balanceListTable td {
    padding: 7px 0;
    color: #444;
    font-size: 13px;
    border: 1px solid #ccc;
    background-color: #fff;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/M990801.vue